import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export function FooterNotificationOne() {
    const notify = () => toast.success('Thank you very much for BLC email subscription. You will get all news , event and offer news upfront.', {
        position: "top-center",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        });

    return (
      <div>
       
        { notify() &&<ToastContainer position="top-center"
autoClose={8000}
hideProgressBar={false}
newestOnTop={false}
closeOnClick
rtl={false}
pauseOnFocusLoss
draggable
pauseOnHover /> }
      </div>
    );
}


export function FooterNotificationTwo() {
    const notify = () => toast.error('An error oucured , plese try later.', {
        position: "top-center",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        });

    return (
      <div>
       
        { notify() &&<ToastContainer position="top-center"
autoClose={8000}
hideProgressBar={false}
newestOnTop={false}
closeOnClick
rtl={false}
pauseOnFocusLoss
draggable
pauseOnHover /> }
      </div>
    );
}

